import ensureLeafletMap from './leaflet-map'
import { addSpecificPath, deleteMarkersAndPaths, getNavitimeAPIData, searchRoute } from './route-utils'
import L from 'leaflet'
import { toTime } from '../../utils/time-utils'

const mapSelector = '#navitimeMap'

/**
 * Initializes Navitime mapscript map and ensures Leaflet map is created.
 * Exposes navitimeConfig and map on window.
 * @param {{apiUrl:string, customerId:string, signature:string, requestCode:string, toBeLoadedFrom:string}} config
 */
export function initMap(config) {
  if (window.mapscript) {
    try {
      window.navitimeConfig = config
      window.map = new mapscript.Map(navitimeConfig.customerId, {
        target: mapSelector,
        center: new mapscript.value.LatLng(34.72383109685586, 135.45281896187524),
        zoomLevel: 9
      })
      window.map.setMapVectorCondition(new mapscript.value.MapVectorCondition({}))
	  window.map.setWheelZoomEnable(false)
      const zoomIn = document.getElementById('zoomIn')
      const zoomOut = document.getElementById('zoomOut')
      if (zoomIn) zoomIn.onclick = () => map.zoomIn()
      if (zoomOut) zoomOut.onclick = () => map.zoomOut()
      up.emit('app:map-loaded', {})
    } catch (error) {
      console.error('Error initializing the map:', error)
    }
  } else {
    console.info('mapscript is not loaded or available, retrying after sometime')
    setTimeout(function () {
      initMap(config)
    }, 500)
  }

  // Ensure OSM/Leaflet map exists too
  ensureLeafletMap()
}

/**
 * Add a marker to Navitime map and attach info window.
 * @param {{lat:number,lon:number,name:string,arrivalTime?:number,serviceDuration?:number,departureTime?:number}} visit
 */
export function addMarkerToTheMap(visit) {
  if (!visit) return
  const info = new mapscript.value.GLMarkerIconInfo({ icon: '/pin.png' })
  const position = new mapscript.value.LatLng(visit.lat, visit.lon)
  const marker = new mapscript.object.GLMarker({ position, info })
  window.map.addGLMarker(marker)
  const infoWindow = new mapscript.object.InfoWindow({
    content: `
                  <h5>${visit.name}</h5> 到着時刻: ${toTime(visit.arrivalTime)} <br>
                  サービス期間: ${toTime(visit.serviceDuration)} <br>
                  出発時間: ${toTime(visit.departureTime)}`,
    position
  })
  infoWindow.close()
  window.map.addInfoWindow(infoWindow)
  marker.addEventListener('click', () => {
    if (infoWindow.isOpen()) {
      infoWindow.close()
      return
    }
    infoWindow.open()
  })
  window.markers.push(marker)
  window.infoWindows.push(infoWindow)
}

/**
 * Add markers from timeline object and draw Navitime route with optional waypoints.
 * @param {Object} obj
 * @param {Object} alpineComponent
 */
export function addMarkersAndPaths(obj, alpineComponent) {
  for (const v of obj.timeline) {
    addMarkerToTheMap(v.visit)
  }

  const wayPoints = []
  for (let i = 1; i < obj.track.length - 1; i++) {
    if (obj.track[i].lat === 0) continue
    wayPoints.push({ lat: obj.track[i].lat, lon: obj.track[i].lon, name: obj.timeline[i].name })
  }
  const DateTime = alpineComponent.date + 'T09:00:00'

  if (routePath.length !== 0) {
    for (let i = 0; i < routePath.length; i++) {
      routePath.forEach(function (r) {
        map.removeGeoJsonFigure(r)
      })
    }
    routePath = []
  }

  const start = { coord: { lon: obj.track[0].lon, lat: obj.track[0].lat }, node: '', name: obj.timeline[0].name }
  const goal = { coord: { lon: obj.track[0].lon, lat: obj.track[0].lat }, node: '', name: obj.timeline[0].name }
  const { params } = getNavitimeAPIData(DateTime, start, goal, wayPoints)
  searchRoute(params, 27000000 /* set to 7:30 AM */, alpineComponent)
}

/**
 * Render a Leaflet route between two points for visual feedback on the OSM map.
 * @param {*} from
 * @param {*} to
 * @param {*} alpineComponent
 */
export function renderLeafletRoute(from, to, alpineComponent) {
  const source = L.latLng(from.lat, from.lon)
  const dest = L.latLng(to.lat, to.lon)
  if (window.currentRoute) {
    window.leafletMap.removeControl(window.currentRoute)
  }
  window.currentRoute = L.Routing.control({
    waypoints: [source, dest],
    routeWhileDragging: false,
    show: false,
    lineOptions: { styles: [{ color: 'red', opacity: 1, weight: 13 }, { color: 'lightgreen', opacity: 0.9, weight: 8 }] }
  }).addTo(window.leafletMap)
}

export default {
  initMap,
  addMarkerToTheMap,
  addMarkersAndPaths,
  renderLeafletRoute
}
